var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from "vue";
import { mapState } from "vuex";
import gql from "graphql-tag";
import { getSingleIntQueryValue, getSingleQueryValue, } from "../../../utils/request";
import { createMetaDescription } from "../../../utils/meta";
import { mapboxStaticMapUrl } from "../../../utils/mapbox";
import PaginationLinks from "../../ui/PaginationLinks.vue";
import institutionDisplayNameFragment from "../../../utils/institutionDisplayNameFragment.graphql";
import SearchPropertyCard from "./SearchPropertyCard.vue";
import SearchFilters from "./SearchFilters.vue";
import SearchMapDialog from "./map/SearchMapDialog.vue";
import SearchFiltersDialog from "./SearchFiltersDialog.vue";
import PropertyCardLoading from "./PropertyCardLoading.vue";
var pageSize = 10;
export default Vue.extend({
    components: {
        SearchPropertyCard: SearchPropertyCard,
        SearchFilters: SearchFilters,
        SearchFiltersDialog: SearchFiltersDialog,
        SearchMapDialog: SearchMapDialog,
        PropertyCardLoading: PropertyCardLoading,
        PaginationLinks: PaginationLinks,
    },
    data: function () {
        return {
            orderByOptions: [
                { label: this.$t("Nearest to").toString(), value: "nearest-to" },
                { label: this.$t("Furthest from").toString(), value: "furthest-from" },
            ],
            pageSize: pageSize,
            orderBy: getSingleQueryValue(this.$route, "orderBy", "nearest-to"),
            areFiltersOpen: false,
        };
    },
    computed: __assign({ totalProperties: function () {
            if (this.livePropertiesSearchPage) {
                return this.livePropertiesSearchPage.totalItems;
            }
            return undefined;
        }, searchName: function () {
            if (this.$route.params.institutionSlug && this.institutionBySlug) {
                return this.institutionBySlug.name;
            }
            if (this.cityBySlug) {
                return this.cityBySlug.name;
            }
            return undefined;
        }, staticMapUrl: function () {
            var _this = this;
            var getSearchLatLong = function () {
                if (_this.$route.params.institutionSlug && _this.institutionBySlug) {
                    return _this.institutionBySlug.latLong;
                }
                if (_this.cityBySlug) {
                    return _this.cityBySlug.latLong;
                }
                return undefined;
            };
            var latLong = getSearchLatLong();
            if (!latLong || !this.mapboxAccessToken) {
                return undefined;
            }
            return mapboxStaticMapUrl(this.mapboxAccessToken, latLong, {
                width: 268,
                height: 200,
            });
        }, breadcrumbs: function () {
            var items = [{ name: "Accommodation", link: "/accommodation/" }];
            if (this.cityBySlug) {
                items.push({
                    name: this.cityBySlug.name,
                    link: "/accommodation/".concat(this.cityBySlug.slug),
                });
            }
            if (this.cityBySlug && this.institutionBySlug) {
                items.push({
                    name: this.institutionBySlug.name,
                    link: "/accommodation/".concat(this.cityBySlug.slug, "/").concat(this.institutionBySlug.slug),
                });
            }
            return items;
        }, page: function () {
            if (this.livePropertiesSearchPage) {
                return this.livePropertiesSearchPage.items;
            }
            return [];
        }, pageIndex: function () {
            return getSingleIntQueryValue(this.$route, "page", 1) - 1;
        }, leftColumn: function () {
            return this.page.filter(function (_, i) { return i % 2 === 0; });
        }, rightColumn: function () {
            return this.page.filter(function (_, i) { return i % 2 === 1; });
        }, institutionOptions: function () {
            if (this.cityBySlug) {
                return this.cityBySlug.institutions;
            }
            return [];
        }, linkQuery: function () {
            if (this.institutionBySlug) {
                return { institution: this.institutionBySlug.slug };
            }
            return {};
        } }, mapState(["mapboxAccessToken"])),
    methods: {
        onOrderByChange: function (orderBy) {
            this.$router.push({ query: __assign(__assign({}, this.$route.query), { orderBy: orderBy }) });
        },
        onOpenFilters: function () {
            this.areFiltersOpen = true;
        },
        onCloseFilters: function () {
            this.areFiltersOpen = false;
        },
    },
    apollo: {
        livePropertiesSearchPage: {
            query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query SearchQuery(\n          $city: String\n          $institution: String\n          $propertyTypes: [String!]\n          $roomTypes: [String!]\n          $priceFrom: Int\n          $priceTo: Int\n          $moveInDate: Date\n          $distanceToCitySlug: String\n          $distanceToInstitutionSlug: String\n          $orderBy: String!\n          $pageIndex: Int!\n          $pageSize: Int!\n        ) {\n          livePropertiesSearchPage(\n            city: $city\n            institution: $institution\n            propertyTypes: $propertyTypes\n            roomTypes: $roomTypes\n            rentalPerWeekFrom: $priceFrom\n            rentalPerWeekTo: $priceTo\n            moveInDate: $moveInDate\n            orderBy: $orderBy\n            pageIndex: $pageIndex\n            pageSize: $pageSize\n          ) {\n            totalItems\n            items {\n              id\n              ...SearchPropertyCard_property\n            }\n          }\n        }\n        ", "\n      "], ["\n        query SearchQuery(\n          $city: String\n          $institution: String\n          $propertyTypes: [String!]\n          $roomTypes: [String!]\n          $priceFrom: Int\n          $priceTo: Int\n          $moveInDate: Date\n          $distanceToCitySlug: String\n          $distanceToInstitutionSlug: String\n          $orderBy: String!\n          $pageIndex: Int!\n          $pageSize: Int!\n        ) {\n          livePropertiesSearchPage(\n            city: $city\n            institution: $institution\n            propertyTypes: $propertyTypes\n            roomTypes: $roomTypes\n            rentalPerWeekFrom: $priceFrom\n            rentalPerWeekTo: $priceTo\n            moveInDate: $moveInDate\n            orderBy: $orderBy\n            pageIndex: $pageIndex\n            pageSize: $pageSize\n          ) {\n            totalItems\n            items {\n              id\n              ...SearchPropertyCard_property\n            }\n          }\n        }\n        ", "\n      "])), SearchPropertyCard.options.fragments.property),
            variables: function () {
                var citySlug = this.$route.params.institutionSlug
                    ? undefined
                    : this.$route.params.citySlug;
                return {
                    city: citySlug,
                    institution: this.$route.params.institutionSlug,
                    propertyTypes: this.$route.query.propertyTypes,
                    roomTypes: this.$route.query.roomTypes,
                    priceFrom: this.$route.query.priceFrom,
                    priceTo: this.$route.query.priceTo,
                    moveInDate: this.$route.query.moveInDate,
                    distanceToCitySlug: citySlug,
                    distanceToInstitutionSlug: this.$route.params.institutionSlug,
                    orderBy: this.$route.query.orderBy || this.orderBy,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                };
            },
        },
        cityBySlug: {
            query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        query SearchCityQuery($slug: String!) {\n          cityBySlug(slug: $slug) {\n            slug\n            name\n            latLong {\n              lat\n              long\n            }\n            institutions {\n              slug\n              ...InstitutionDisplayName_institution\n            }\n          }\n        }\n        ", "\n      "], ["\n        query SearchCityQuery($slug: String!) {\n          cityBySlug(slug: $slug) {\n            slug\n            name\n            latLong {\n              lat\n              long\n            }\n            institutions {\n              slug\n              ...InstitutionDisplayName_institution\n            }\n          }\n        }\n        ", "\n      "])), institutionDisplayNameFragment),
            variables: function () {
                return {
                    slug: this.$route.params.citySlug,
                };
            },
        },
        institutionBySlug: {
            query: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        query SearchInstitutionQuery($slug: String!) {\n          institutionBySlug(slug: $slug) {\n            slug\n            name\n            latLong {\n              lat\n              long\n            }\n          }\n        }\n      "], ["\n        query SearchInstitutionQuery($slug: String!) {\n          institutionBySlug(slug: $slug) {\n            slug\n            name\n            latLong {\n              lat\n              long\n            }\n          }\n        }\n      "]))),
            variables: function () {
                return {
                    slug: this.$route.params.institutionSlug,
                };
            },
            skip: function () {
                return !this.$route.params.institutionSlug;
            },
        },
    },
    metaInfo: function () {
        return {
            title: this.searchName,
            meta: [
                createMetaDescription("Search for student accommodation in Australia"),
            ],
        };
    },
});
var templateObject_1, templateObject_2, templateObject_3;
